<template>
  <footer>
    <div class="footer-services main-center clearfix">
      <div class="slogen">
        <div class="box">
          <img
            src="@/assets/images/brand.png?q=80&c=1&f=webp"
            class="box-img"
          />
          <span>品牌直营</span>
        </div>
        <div class="box">
          <img
            src="@/assets/images/member.png?q=80&c=1&f=webp"
            class="box-img"
          />
          <span>会员权益</span>
        </div>
        <div class="box">
          <img
            src="@/assets/images/service.png?q=80&c=1&f=webp"
            class="box-img"
          />
          <span>专属服务</span>
        </div>
        <div class="box">
          <img
            src="@/assets/images/refund.png?q=80&c=1&f=webp"
            class="box-img"
          />
          <span>退换无忧</span>
        </div>
      </div>
    </div>
    <div class="footer-links main-center">
      <!-- <div class="links">
        <dl v-for="(item, index) in links" :key="index">
          <dt>{{ item.title }}</dt>
          <dd v-for="(val, key) in item.children" :key="key">
            <a v-if="val.url" :href="val.url">{{ val.title }}</a>
            <span v-else>{{ val.title }}</span>
          </dd>
        </dl>
      </div> -->
      <div class="serviceList list">
        <div class="type">服务支持</div>
        <a
          v-for="(item, index) in linkType.serviceList"
          :key="index"
          :href="item.url"
          target="_blank"
          >{{ item.name }}</a
        >
      </div>
      <div class="applicationList list">
        <div class="type">应用服务</div>
        <a
          v-for="(item, index) in linkType.applicationList"
          :key="index"
          :href="item.url"
          target="_blank"
          >{{ item.name }}</a
        >
      </div>
      <div class="friendshipList list">
        <div class="type">友情链接</div>
        <a
          v-for="(item, index) in linkType.friendshipList"
          :key="index"
          :href="item.url"
          target="_blank"
          >{{ item.name }}</a
        >
      </div>
      <div class="aboutUsList list">
        <div class="type">关于我们</div>
        <a
          v-for="(item, index) in linkType.aboutUsList"
          :key="index"
          :href="item.url"
          target="_blank"
          >{{ item.name }}</a
        >
      </div>
      <div class="QRcode">
        <img
          src="//img.xunfei.cn/mall/common-resource-img/qr/qr_ffzj.png?q=80&c=1&f=webp"
          alt=""
        />
        <p>讯飞会员服务</p>
      </div>
      <div class="QRcode">
        <img
          src="//img.xunfei.cn/mall/common-resource-img/qr/qr-qigkf.jpg?q=80&f=webp"
          alt=""
        />
        <p>企业团购</p>
      </div>
      <div class="contacts">
        <div class="btn-wrap">
          <a class="btn primary" @click="handleBeforeSale">
            <i></i>
            <span>在线客服</span>
          </a>
        </div>
        <div class="phone">4000-199-199</div>
        <div class="worktime">工作时间：08:30-22:00</div>
        <div class="worktime">(节假日不休)</div>
        <!-- <div class="worktime">工作时间：7*24小时</div> -->
      </div>
    </div>
    <div class="footer-copyright">
      <div class="main-center">
        <!-- <br /> -->
        <span
          >copyright © 2017,iflytek Co.,Ltd.All Rights Reserved.
          科大讯飞股份有限公司 版权所有 保留一切权利 |</span
        >
        <a href="http://x.xunfei.cn/mall/privacy.html" target="_blank"
          >隐私政策</a
        >
        |
        <a href="http://x.xunfei.cn/mall/Agreement.html" target="_blank"
          >用户协议</a
        >
        | <span>皖ICP备05001217号</span> |
        <span>皖公网安备 34019202000119号</span> |
        <span>备案主体编号 34201929030521</span>
      </div>
    </div>
    <customer-service :visible.sync="serviceVisible" />
  </footer>
</template>

<script>
export default {
  name: "TheFooter",
  data() {
    return {
      // links: [
      //   {
      //     title: "服务支持",
      //     children: [
      //       { title: "授权中心", url: "https://www.xunfei.cn/brandAuth/" },
      //       { title: "门店查询", url: "https://www.xunfei.cn/ifly-mall-lsd/" },
      //       { title: "讯飞教育云", url: "https://www.jyyun.com/" },
      //       { title: "讯飞开放平台", url: "https://www.xfyun.cn/" },
      //     ],
      //   },
      //   {
      //     title: "应用服务",
      //     children: [
      //       { title: "讯飞输入法", url: "https://srf.xunfei.cn/" },
      //       { title: "讯飞文档", url: "https://www.iflydocs.com" },
      //       { title: "讯飞智作", url: "http://peiyin.xunfei.cn/" },
      //       { title: "讯飞听见", url: "https://www.iflyrec.com/" },
      //       { title: "讯飞语记", url: "https://iflynote.com/home" },
      //       { title: "讯飞虚拟人", url: "http://zhisheng.xunfei.cn" },
      //       { title: "酷音铃声", url: "https://www.diyring.cc/" },
      //     ],
      //   },
      //   {
      //     title: "友情链接",
      //     children: [
      //       { title: "方言保护计划", url: "https://fangyan.xunfei.cn/" },
      //     ],
      //   },
      //   {
      //     title: "关于我们",
      //     children: [
      //       { title: "科大讯飞", url: "https://www.iflytek.com/" },
      //       {
      //         title: "讯飞云展厅",
      //         url: "https://720yun.com/vr/5a32ej8gcer",
      //       },
      //     ],
      //   },
      // ],
      linkType: {
        serviceList: [
          // {
          //   name: "授权中心",
          //   url: "https://www.xunfei.cn/brandAuth/",
          // },
          {
            name: "门店查询",
            url: "https://www.xunfei.cn/ifly-mall-lsd/",
          },
          {
            name: "讯飞教育云",
            url: "https://www.jyyun.com/",
          },
          {
            name: "讯飞开放平台",
            url: "https://www.xfyun.cn/",
          },
        ],
        applicationList: [
          {
            name: "讯飞输入法",
            url: "https://srf.xunfei.cn/",
          },

          {
            name: "讯飞文档",
            url: "https://www.iflydocs.com",
          },
          {
            name: "讯飞智作",
            url: "http://peiyin.xunfei.cn/",
          },
          {
            name: "讯飞听见",
            url: "https://www.iflyrec.com/",
          },
          {
            name: "讯飞语记",
            url: "https://iflynote.com/home",
          },
          {
            name: "讯飞虚拟人",
            url: "http://zhisheng.xunfei.cn",
          },
          {
            name: "酷音铃声",
            url: "https://www.diyring.cc/",
          },
        ],
        friendshipList: [
          {
            name: "方言保护计划",
            url: "https://fangyan.xunfei.cn/",
          },
        ],
        aboutUsList: [
          {
            name: "科大讯飞",
            url: "https://www.iflytek.com/",
          },

          {
            name: "讯飞云展厅",
            url: "https://720yun.com/vr/5a32ej8gcer",
          },
        ],
      },
      qiaoLink:
        "https://p.qiao.baidu.com/cps4/chatIndex?siteToken=53b3e7c8e4e65c26355d5f1f1e12367e&speedLogId=158978440426715a7_1589784404267_52661&eid=24677211&reqParam=%7B%22from%22%3A0%2C%22sid%22%3A%22-100%22%2C%22tid%22%3A%22-1%22%2C%22ttype%22%3A1%2C%22siteId%22%3A%2211420354%22%2C%22userId%22%3A%2224677211%22%2C%22pageId%22%3A0%7D",
      aftersaleLink: "https://xffk.iflytek.com/pc/#/?configId=1616546889937",
      serviceVisible: false,
    };
  },
  methods: {
    handleBeforeSale() {
      // window.open(ysf('url'));
      this.serviceVisible = true;
    },
  },
};
</script>

<style lang="less" scoped>
footer {
  background-color: #fff;
  a:hover {
    color: #00adde;
  }
  .footer-services {
    margin-top: 40px;
    padding: 27px 0;
    .slogen {
      display: flex;
      justify-content: space-between;
      align-items: center;
      height: 130px;
      margin: 0 auto;
      border-bottom: 1px solid #e6e6e6;
      color: #333;
      .box {
        display: flex;
        align-items: center;
        position: relative;

        &:first-child {
          justify-content: flex-start;
          width: 260px;
        }

        &:nth-child(2) {
          width: 240px;
        }

        &:nth-child(3) {
          width: 240px;
        }

        &:last-child {
          width: 120px;
        }

        &:not(:last-child)::after {
          content: "";
          position: absolute;
          right: 0;
          top: 50%;
          transform: translateY(-50%);
          width: 1px;
          height: 40px;
          background-color: #e6e6e6;
        }

        .box-img {
          width: 38px;
          height: 38px;
          margin-right: 10px;
        }

        > span {
          font-size: 16px;
          font-weight: 500;
          color: #333;
        }
      }
    }
  }

  .footer-links {
    display: flex;
    justify-content: space-between;
    margin: 0 auto;
    padding: 20px 0;
    > .list {
      display: flex;
      flex-direction: column;
      font-size: 14px;
      .type {
        font-weight: bold;
        color: #333;
      }
      a {
        padding-top: 14px;
        text-decoration: none;
        color: #7a7a7a;
        cursor: pointer;
        &:hover {
          color: #00adde;
        }
      }
    }
  }
  // 公众号和企业微信二维码
  .QRcode {
    text-align: center;
    img {
      width: 100px;
    }
    p {
      margin-top: 8px;
      font-size: 14px;
      color: #7a7a7a;
    }
  }

  .contacts {
    display: flex;
    flex-direction: column;
    align-items: center;
    .btn-wrap {
      .btn {
        float: right;
        display: block;
        cursor: pointer;
        width: 140px;
        height: 44px;
        margin-bottom: 20px;
        border-radius: 4px;
        &.primary {
          background: #f34141;
          color: #ffffff;
          i {
            background-image: url("http://img.xunfei.cn/mall/common-resource-img/images/AFT-SALES.png");
          }
        }
        &.default {
          border: 1px solid #cbcbcb;
          color: #747474;
          i {
            margin: 7px 0 15px 25px;
            width: 35px;
            height: 35px;
            background-image: url("http://img.xunfei.cn/mall/common-resource-img/images/AFT-SALE.png");
          }
        }
        i {
          float: left;
          width: 26px;
          height: 24px;
          fill: #666666;
          margin: 10px 0px 10px 24px;
          border: 0px;
          background-size: 100%;
          background-repeat: no-repeat;
        }
        span {
          width: 65px;
          float: right;
          margin: 14px 20px 14px 0px;
          font-family: PingFangSC-Regular;
          font-size: 16px;
          letter-spacing: 0;
          line-height: 16px;
        }
      }
    }
    .phone {
      line-height: 29px;
      font-family: AvenirLTStd-Roman;
      font-size: 22px;
      color: #171717;
      text-align: center;
      font-weight: bold;
    }
    .worktime {
      font-family: PingFangSC-Regular;
      font-size: 14px;
      line-height: 19px;
      color: #999999;
      margin-right: 0;
      width: auto;
      text-align: center;
    }
  }
}

.footer-copyright {
  padding: 22px 0;
  background: #f5f5f5;
  text-align: center;
  font-size: 12px;
  line-height: 12px;
  color: #666;
}
</style>
